import React from 'react';
import PropTypes, { object } from 'prop-types';

import { Text } from 'components/common/Elements/Elements';

import classes from './Legend.module.scss';

const Legend = ({ config, setConfig }) => {
  const labelChange = e => {
    const findInConf = item => item.name === e.target.name;
    const ind = config.findIndex(findInConf);
    const newValue = !config[ind].value;
    setConfig(
      config.map(item =>
        item.name === e.target.name ? { ...item, value: newValue } : item
      )
    );
  };

  return (
    <div className={classes.legend}>
      {config.map(item => {
        if (!item.invisible) {
          return (
            <label className={classes.label} key={item.name}>
              <input
                onChange={labelChange}
                className={classes.visually_hidden}
                type="checkbox"
                name={item.name}
                value={item.value}
              />
              <div
                className={classes.square}
                style={{
                  border: `1px solid ${item.color}`,
                  backgroundColor: item.value ? item.color : 'transparent'
                }}
              ></div>
              <Text className={classes.label_text}>{item.name}</Text>
            </label>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
};

Legend.propTypes = {
  config: PropTypes.arrayOf(object),
  setConfig: PropTypes.func
};

export default Legend;
